import { newLine } from '../../../../constants/textConstants';

export const getTooltipContent = (event, deliveryMethod) =>
  `${event.OrgUnitNames}${newLine}ATL: ${event.AtlName || 'TBD'}${
    deliveryMethod ? `${newLine}${deliveryMethod.label}` : ''
  }`;
